import React from 'react';
import { ChatMessage as ChatMessageType, ChatAction } from './ChatbotContext';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const { text, type, isLoading, actions } = message;

  // Render different message types with different styles
  const renderMessage = () => {
    if (isLoading) {
      return (
        <div className="flex items-center space-x-2">
          <div className="h-2 w-2 animate-bounce rounded-full bg-gray-400"></div>
          <div className="h-2 w-2 animate-bounce rounded-full bg-gray-400" style={{ animationDelay: '0.2s' }}></div>
          <div className="h-2 w-2 animate-bounce rounded-full bg-gray-400" style={{ animationDelay: '0.4s' }}></div>
        </div>
      );
    }

    return (
      <div className="whitespace-pre-wrap break-words">{text}</div>
    );
  };

  // Render action buttons
  const renderActions = () => {
    if (!actions || actions.length === 0) return null;

    return (
      <div className="mt-2 flex flex-wrap gap-2">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.action}
            className="rounded-md bg-primary-500 px-3 py-1 text-sm text-white hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          >
            {action.label}
          </button>
        ))}
      </div>
    );
  };

  return (
    <div
      className={`mb-4 flex ${
        type === 'user' ? 'justify-end' : 'justify-start'
      }`}
    >
      <div
        className={`max-w-[80%] rounded-lg px-4 py-2 ${
          type === 'user'
            ? 'bg-primary-500 text-white'
            : type === 'system'
            ? 'bg-gray-200 text-gray-700 italic'
            : 'bg-gray-100 text-gray-800'
        }`}
      >
        {renderMessage()}
        {renderActions()}
      </div>
    </div>
  );
};

export default ChatMessage;
